import { h } from "preact";

import { imageUrl } from "../../../foundation/utils/image";

import styles from "./ImageFigmaLoveZeplin.module.css";

const FIGMA_LOVE_ZEPLIN_IMAGE_URLS = [
    imageUrl("img/icFigmaLogo.svg"),
    imageUrl("img/icHearts.svg"),
    imageUrl("img/icZeplin.svg")
];

function ImageFigmaLoveZeplin() {
    return (
        <div class={styles.figmaLoveZeplin}>
            <img class={styles.figma} src={imageUrl("img/icFigmaLogo.svg")}/>
            <img class={styles.hearts} src={imageUrl("img/icHearts.svg")}/>
            <img src={imageUrl("img/icZeplin.svg")}/>
        </div>
    );
}

export default ImageFigmaLoveZeplin;
export {
    FIGMA_LOVE_ZEPLIN_IMAGE_URLS
};
